/**
 * Internal-only OG renderer at /og/home — pixel-perfect 1200×630.
 * Captured once and saved to /public/images/og-image.png (the default
 * image referenced by every page's SEOHead).
 *
 * DO NOT add this to the public nav. URL exists for screenshot capture only.
 */
import React from 'react';

const OgHome = () => {
  return (
    <div style={{
      width: 1200, height: 630, background: '#020617',
      fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
      color: '#f1f5f9', overflow: 'hidden', position: 'relative',
      display: 'flex', flexDirection: 'column', padding: '64px',
    }}>
      {/* Background accent gradients */}
      <div style={{
        position: 'absolute', top: -200, left: -140,
        width: 700, height: 700, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(16,185,129,0.22) 0%, rgba(16,185,129,0) 60%)',
        filter: 'blur(50px)',
      }} />
      <div style={{
        position: 'absolute', bottom: -220, right: -160,
        width: 750, height: 750, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(34,211,238,0.14) 0%, rgba(34,211,238,0) 60%)',
        filter: 'blur(60px)',
      }} />

      {/* Faint grid */}
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.4,
        backgroundImage: 'linear-gradient(rgba(16,185,129,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(16,185,129,0.08) 1px, transparent 1px)',
        backgroundSize: '40px 40px',
        maskImage: 'radial-gradient(ellipse at center, black 35%, transparent 80%)',
        WebkitMaskImage: 'radial-gradient(ellipse at center, black 35%, transparent 80%)',
      }} />

      {/* TOP BAR — brand + live indicator */}
      <div style={{
        position: 'relative', display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <img
            src="/logo192.png"
            alt="CARTIEAI"
            width={44}
            height={44}
            style={{ borderRadius: 12, background: '#ffffff', objectFit: 'cover' }}
          />
          <span style={{
            fontSize: 20, fontWeight: 600, letterSpacing: 0.5,
            color: '#f8fafc',
          }}>CARTIE<span className="text-emerald-400">AI</span></span><sup className="ml-0.5 text-[0.55em] font-bold text-emerald-300 align-super tracking-normal">™</sup>
        </div>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 8,
          padding: '6px 14px', borderRadius: 999,
          background: 'rgba(16,185,129,0.12)',
          border: '1px solid rgba(52,211,153,0.4)',
        }}>
          <span style={{
            width: 8, height: 8, borderRadius: '50%',
            background: '#34d399',
            boxShadow: '0 0 14px rgba(52,211,153,0.85)',
          }} />
          <span style={{
            fontSize: 12, fontWeight: 700, letterSpacing: 2.5,
            color: '#a7f3d0', textTransform: 'uppercase',
          }}>Beta · Free Access</span>
        </div>
      </div>

      {/* HEADLINE */}
      <div style={{
        position: 'relative', marginTop: 60, flex: 1,
        display: 'flex', flexDirection: 'column', justifyContent: 'center',
      }}>
        <div style={{
          fontSize: 13, fontWeight: 700, letterSpacing: 4,
          color: '#34d399', textTransform: 'uppercase', marginBottom: 18,
        }}>AI-Powered Cloud Cost Intelligence</div>
        <h1 style={{
          fontSize: 78, lineHeight: 1.03, fontWeight: 800,
          letterSpacing: -1.8, margin: 0, color: '#f8fafc',
        }}>
          Stop overpaying<br />
          for cloud{' '}
          <span style={{
            background: 'linear-gradient(90deg, #6ee7b7 0%, #67e8f9 100%)',
            WebkitBackgroundClip: 'text', backgroundClip: 'text',
            WebkitTextFillColor: 'transparent', color: 'transparent',
          }}>+ AI tokens.</span>
        </h1>
        <p style={{
          fontSize: 22, color: '#cbd5e1', marginTop: 22,
          maxWidth: 880, lineHeight: 1.45,
        }}>
          AWS · Azure · GCP · Snowflake · Databricks · AI tokens · in one platform.
        </p>
      </div>

      {/* CLOUD PROVIDER STRIP */}
      <div style={{
        position: 'relative', display: 'flex', gap: 10, marginTop: 12, flexWrap: 'wrap',
      }}>
        {['AWS', 'Azure', 'GCP', 'Snowflake', 'Databricks', '+ 11 LLMs'].map((p) => (
          <span key={p} style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            padding: '8px 14px', borderRadius: 8,
            background: 'rgba(15,23,42,0.7)',
            border: '1px solid rgba(255,255,255,0.06)',
            fontSize: 14, fontWeight: 500, color: '#cbd5e1',
          }}>
            <span style={{
              width: 6, height: 6, borderRadius: '50%', background: '#34d399',
            }} />
            {p}
          </span>
        ))}
      </div>

      {/* BOTTOM URL BAR */}
      <div style={{
        position: 'relative', marginTop: 32, display: 'flex',
        alignItems: 'center', justifyContent: 'space-between',
        paddingTop: 20, borderTop: '1px solid rgba(255,255,255,0.06)',
      }}>
        <div style={{ fontSize: 18, color: '#94a3b8', letterSpacing: 0.3 }}>
          <span style={{ color: '#6ee7b7', fontWeight: 600 }}>cartieai.com</span>
        </div>
        <div style={{ fontSize: 14, color: '#64748b', letterSpacing: 0.5 }}>
          15 free tools · no signup · 14-day Pro trial
        </div>
      </div>
    </div>
  );
};

export default OgHome;
